import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll<HTMLElement>('.splide-gallery-inner')
    .forEach((element) => {
      var mainElement = element.querySelector<HTMLElement>('.splide-main');

      var thumbnailsElement = element.querySelector<HTMLElement>('.splide-thumbnails');
      if (mainElement && thumbnailsElement) {

        let main = new Splide(mainElement);

        let thumbnails = new Splide(thumbnailsElement);

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
      }
    });

  document.querySelectorAll<HTMLElement>('.static-splide')
    .forEach((element) => {
      let splide = new Splide(element);
      splide.mount();
    });
});

export function createSplide(element: HTMLElement, options: any) {
  let splide = new Splide(element, options);
  splide.mount();
}
